import React from "react";
import {GridTable, ResultsPager} from "../../../../Components/Grid";
import {BraillerCatalogResultsRow} from "./BraillerCatalogResultsRow";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import type {BraillerCatalogSearchCriteria} from "./braillerCatalog.types";

interface BraillerSearchResultsViewProps {
    catalogResources: Record<string, any>[];
    catalogSearchCriteria: BraillerCatalogSearchCriteria;
    canManageCatalog: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
    handleSetSearchCriteria: (criteria: BraillerCatalogSearchCriteria) => void;
    totalRecords: number;
    handleRepairs?: (id: string) => void;
}

export const BraillerSearchResultsView = ({
                                              catalogResources,
                                              catalogSearchCriteria,
                                              canManageCatalog,
                                              handleAddToQueue,
                                              handleEdit,
                                              handleSetSearchCriteria,
                                              totalRecords,
                                              handleRepairs,
                                          }: BraillerSearchResultsViewProps) => {
    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true};
        criteria.UpdateSorting((event.target as HTMLElement).dataset.id || '');
        handleSetSearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true};
        criteria.First();
        handleSetSearchCriteria(criteria);
    };

    const handlePreviousClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true};
        criteria.Previous();
        handleSetSearchCriteria(criteria);
    };

    const handleNextClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true};
        criteria.Next();
        handleSetSearchCriteria(criteria);
    };

    const handleLastClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true};
        criteria.Last(totalRecords);
        handleSetSearchCriteria(criteria);
    };

    const pager = (isSecondaryPager: boolean) => (
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={catalogSearchCriteria.recordsPerPage}
            currentPage={catalogSearchCriteria.page}
            disabled={false}
        />
    );

    const noResults = isArrayNullOrEmpty(catalogResources);

    return (
        <>
            {pager(false)}
            <GridTable className="searchResults">
                <thead>
                <tr>
                    <th
                        onClick={handleOrderClick}
                        className="is-clickable"
                        data-id="title"
                    >
                        Title
                    </th>
                    <th
                        onClick={handleOrderClick}
                        className="is-clickable"
                        data-id="model"
                    >
                        Model
                    </th>
                    <th
                        onClick={handleOrderClick}
                        className="is-clickable"
                        data-id="cost"
                    >
                        Cost
                    </th>
                    <th data-id="availability">Availability</th>
                    <th data-id="actions">Actions</th>
                </tr>
                </thead>
                <tbody>
                {!noResults &&
                    catalogResources.map((catalogResource: Record<string, any>) => {
                        return (
                            <BraillerCatalogResultsRow
                                key={catalogResource.braillerCatalogId}
                                catalogResource={catalogResource}
                                canManageCatalog={canManageCatalog}
                                handleAddToQueue={handleAddToQueue}
                                handleEdit={handleEdit}
                                handleRepairs={handleRepairs}
                            />
                        );
                    })}
                {noResults && (
                    <tr data-testid="no-results-row">
                        <td colSpan={5} className="text-center">
                            No results found.
                        </td>
                    </tr>
                )}
                </tbody>
            </GridTable>
            {pager(true)}
        </>
    );
};
